module.exports = __webpack_public_path__ + "static/media/play.acd459d1.svg";